class Canvas {
  canvas: HTMLCanvasElement;

  initialized = false;

  // flag to signal clearing of the canvas. done on every tick before any draw calls.
  clear = true;

  // Monitor the size of the canvas, and set its width and height if needed.
  monitorResize = false;

  constructor(canvas = document.createElement('canvas')) {
    this.canvas = canvas;
  }
}

export default Canvas;
